export function WorkOrdersPage({ render }) {
  return render();
}

export function WorkOrderEditor({ render }) {
  return render();
}
